exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3WE8MsLxwNqIcFoTYVtQSI{float:left;line-height:1.8;padding-right:1rem;width:100%}._3WE8MsLxwNqIcFoTYVtQSI:after{background:#ccc;content:\"\";display:block;height:.07143rem;left:0;position:absolute;width:100%}._1AxewpG5ZPEaZIqseJCAcK{color:#b4b4b4;font-size:.95em;font-weight:400;margin:0}._3z3afrpOgB_d0Nvsg27KGG{border-bottom:.07143rem solid transparent;font-size:1rem;margin:0;padding-bottom:.57143rem;white-space:pre-line}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReadOnlyField_board": "_3WE8MsLxwNqIcFoTYVtQSI",
	"ReadOnlyField_h5": "_1AxewpG5ZPEaZIqseJCAcK",
	"ReadOnlyField_p": "_3z3afrpOgB_d0Nvsg27KGG"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanDetailView/ReadOnlyField/style.postcss
// module id = 1775
// module chunks = 0